import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/b-layout/index.vue'
import VueI18n from 'vue-i18n';
import en from '../locale/en.json';
import sw from '../locale/sw.json';

Vue.use(VueRouter)

const routes = [
    // 重定向
    {
        path: "/redirect",
        name: "REDIRECT",
        component: () => import('@/views/redirect/index.vue'),
        meta: { hideNavBar: true, index: 0 }
    },

    {
        path: "/",
        name: "/",
        component: Layout,
        redirect: '/redirect',
        children: [
            {
                path: "/authorization",
                name: "AUTHORIZATION",
                component: () => import('@/views/authorization/index.vue'),
                meta: { title: 'routeTitle.Authorization', hideBackIcon: true, index: 1 }
            },
            {
                path: "/home",
                name: "HOME",
                component: () => import('@/views/home/index.vue'),
                meta: { title: 'homePage', hideNavBar: true, index: 0, statusbarColor: '#fc9a1d' }
            },
            // 我的
            {
                path: "/mine",
                name: "MINE",
                component: () => import('@/views/mine/index.vue'),
                meta: { title: 'Me', hideNavBar: true, index: 1, statusbarColor: '#f9971f' }
            },
            {
                path: "/mine/settings",
                name: "SETTINGS",
                component: () => import('@/views/mine/settings/index.vue'),
                meta: { title: 'routeTitle.Settings', index: 1 }
            },
            {
                path: "/mine/settings/aboutUs",
                name: "SETTINGS-ABOUTUS",
                component: () => import('@/views/mine/settings/aboutUs.vue'),
                meta: { title: 'mineSetting.card2', index: 1 }
            },
            {
                path: "/mine/settings/contactUs",
                name: "SETTINGS-CONTACTUS",
                component: () => import('@/views/mine/settings/contactUs.vue'),
                meta: { title: 'mineSetting.card3', index: 1 }
            },
            {
                path: "/mine/settings/deleteAccount",
                name: "SETTINGS-DELETEACCOUNT",
                component: () => import('@/views/mine/settings/deleteAccount.vue'),
                meta: { title: 'Delete Account', index: 1 }
            },
            {
                path: "/mine/agreement",
                name: "AGREEMENT",
                component: () => import('@/views/mine/agreement/index.vue'),
                meta: { title: 'mine.myAgreement', index: 1 }
            },
            {
                path: "/mine/modifyPin/oldPin",
                name: "MODIFYPIN-OLDPIN",
                component: () => import('@/views/mine/modifyPin/oldPin.vue'),
                meta: { title: 'routeTitle.oldPIN', index: 1 }
            },
            {
                path: "/mine/modifyPin/newPin",
                name: "MODIFYPIN-NEWPIN",
                component: () => import('@/views/mine/modifyPin/newPin.vue'),
                meta: { title: 'setPinCode.title', index: 1 }
            },
            {
                path: "/mine/loans",
                name: "LOANS",
                component: () => import('@/views/mine/loans/index.vue'),
                meta: { title: 'routeTitle.Loans', index: 1 }
            },
            {
                path: "/mine/loansDisplay",
                name: "LOANSDISPLAY",
                component: () => import('@/views/mine/loans/display.vue'),
                meta: { title: 'routeTitle.Loans', index: 0, hideNavBar: true }
            },
            {
                path: "/mine/loansExtension",
                name: "LOANSEXTENSION",
                component: () => import('@/views/mine/loans/extension.vue'),
                meta: { title: 'routeTitle.ExtensionDetails', index: 1 }
            },
            {
                path: "/mine/loans/order",
                name: "LOANS-ORDER",
                component: () => import('@/views/mine/loans/detail.vue'),
                meta: { title: 'routeTitle.orderDetails', index: 1 }
            },


            // application 流程
            {
                path: "/application/personalInfo/:type",
                name: "APPLICATION-PERSONALINFO",
                component: () => import('@/views/application/personalInfo.vue'),
                meta: { title: 'routeTitle.personalInfo', index: 1 }
            },
            {
                path: "/application/additionalInfo/:type",
                name: "APPLICATION-ADDITIONALINFO",
                component: () => import('@/views/application/additionalInfo.vue'),
                meta: { title: 'routeTitle.additionalInfo', index: 1 }
            },
            {
                path: "/application/idCard",
                name: "APPLICATION-IDCARD",
                component: () => import('@/views/application/idCard.vue'),
                meta: { title: 'routeTitle.IDCard', index: 1 }
            },
            {
                path: "/application/selfie",
                name: "APPLICATION-SELFIE",
                component: () => import('@/views/application/selfie.vue'),
                meta: { title: 'routeTitle.Selfie', index: 1 }
            },
            {
                path: "/application/orderInfo",
                name: "APPLICATION-ORDERINFO",
                component: () => import('@/views/application/orderInfo.vue'),
                meta: { title: 'routeTitle.creditResult', hideNavBar: true, index: 1, statusbarColor: '#fa9920' }
            },
            {
                path: "/application/waiting",
                name: "APPLICATION-WAITING",
                component: () => import('@/views/application/waiting.vue'),
                meta: { title: 'routeTitle.timeRemaining', index: 1 }
            },
            {
                path: "/application/result/:type",
                name: "APPLICATION-RESULT",
                component: () => import('@/views/application/result.vue'),
                meta: { title: 'routeTitle.applicationResult', index: 1 }
            },

            // 还款 流程
            {
                path: "/repayment",
                name: "REPAYMENT-REPAY",
                component: () => import('@/views/repayment/index.vue'),
                meta: { title: 'routeTitle.repayDetails', hideNavBar: true, index: 1, statusbarColor: '#fa9820' }
            },
            {
                path: "/repayment/result",
                name: "REPAYMENT-RESULT",
                component: () => import('@/views/repayment/result.vue'),
                meta: { title: 'routeTitle.repaymentResult', index: 1 }
            },

            // 登录/注册流程
            {
                path: "/signInUp/pin",
                name: "SIGNINUP-PIN",
                component: () => import('@/views/signInUp/pin.vue'),
                meta: { title: 'PIN', hideNavBar: true, index: 1 }
            },
            {
                path: "/signInUp/code",
                name: "SIGNINUP-CODE",
                component: () => import('@/views/signInUp/code.vue'),
                meta: { title: 'Code', hideNavBar: true, index: 1 }
            },
            {
                path: "/signInUp/countryChange",
                name: "SIGNINUP-COUNTRYCHANGE",
                component: () => import('@/views/signInUp/countryChange.vue'),
                meta: { title: 'routeTitle.selectCountry', index: 1 }
            },
            {
                path: "/signInUp/setPin",
                name: "SIGNINUP-SETPIN",
                component: () => import('@/views/signInUp/setPin.vue'),
                meta: { title: 'routeTitle.SETPIN', hideNavBar: true, index: 1 }
            },
            {
                path: "/signInUp/provacyPolicy",
                name: "PROVACY-POLICY",
                component: () => import('@/views/signInUp/privacyPolicy.vue'),
                meta: { title: 'routeTitle.provacyPolicy', hideNavBar: true, index: 1 }
            },
            {
                path: "/signInUp/termsOfUse",
                name: "TERMS-OF-USE",
                component: () => import('@/views/signInUp/termsOfUse.vue'),
                meta: { title: 'Terms Of Use', hideNavBar: true, index: 1 }
            },


            // 第三方链接
            {
                path: "/links/image",
                name: "LINK-IMAGE",
                component: () => import('@/views/links/image.vue'),
                meta: { title: 'home.bBorrowingGuide', index: 1 }
            },

            // 产品详情
            {
                path: "/production",
                name: "PRODUCTION",
                component: () => import('@/views/product/index.vue'),
                meta: { title: 'orderInfo.production', hideNavBar: true, index: 1 }
            },
            // 产品错误页
            {
                path: "/production/result",
                name: "PRODUCTION_RESULT",
                component: () => import('@/views/product/result.vue'),
                meta: { title: 'production', hideNavBar: true, index: 1 }
            }
        ]
    },
    // 登陆
    {
        path: "/signInUp",
        name: "SIGNINUP",
        component: () => import('@/views/signInUp/index.vue'),
        meta: { title: 'SIGNINUP', hideNavBar: true, index: 0, statusbarColor: '#917222' }
    },

    {
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/404/index.vue'),
    }
]

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes
});

export default router;
